import { render } from "./EconomyBudgetTable.vue?vue&type=template&id=46376f68&ts=true"
import script from "./EconomyBudgetTable.vue?vue&type=script&lang=ts"
export * from "./EconomyBudgetTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__